import { Component, OnInit } from '@angular/core';
import PerfectScrollbar from 'perfect-scrollbar';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { DataService } from '../data-service/data-service.service';
import { HttpService } from '../http-service/http-service.service';
import * as jquery from 'jquery';
declare const $: any;

//Metadata
export interface RouteInfo {
    path: string;
    title: string;
    type: string;
    icontype: string;
    collapse?: string;
    children?: ChildrenItems[];
}

export interface ChildrenItems {
    path: string;
    title: string;
    ab: string;
    type?: string;
}

//Menu Items
export const ROUTES: RouteInfo[] = [
    {
        path: '/dashboard',
        title: 'Dashboard',
        type: 'link',
        icontype: 'dashboard'
    },
    // {
    //     path: '/superadmin-client-list',
    //     title: 'Client',
    //     type: 'link',
    //     icontype: 'assignment_ind'
    // },
    {
        path: '/template',
        title: "Templates",
        // title: 'Template Library',
        type: 'link',
        icontype: 'web'
    }, {
        path: '/content',
        title: "Contents",
        // title: 'Content Management',
        type: 'link',
        icontype: 'picture_in_picture'
    }, {
        path: '/playlist',
        title: 'Playlist',
        // title: 'Playlist Management',
        type: 'link',
        icontype: 'playlist_play'
    }, {
        path: '/schedulelist',
        title: 'Schedules',
        type: 'link',
        icontype: 'date_range'
    }, {
        path: '/playerlist',
        title: "Players",
        type: 'link',
        icontype: 'queue_play_next'
    }, {
        path: '/medialist',
        title: 'Gallery',
        type: 'link',
        icontype: 'subscriptions'
    }, 
];

// {
//     path: '/user',
//     title: "Users",
//     type: 'link',
//     icontype: 'supervisor_account'
// }

//Menu Items
export const ROUTES1: RouteInfo[] = [
    {
        path: '/dashboard',
        title: 'Dashboard',
        type: 'link',
        icontype: 'dashboard'
    },
    // {
    //     path: '/superadmin-client-list',
    //     title: 'Client',
    //     type: 'link',
    //     icontype: 'assignment_ind'
    // },
    {
        path: '/template',
        title: "Templates",
        // title: 'Template Library',
        type: 'link',
        icontype: 'web'
    }, {
        path: '/content',
        title: 'Contents',
        // title: 'Content Management',
        type: 'link',
        icontype: 'picture_in_picture'
    }, {
        path: '/playlist',
        title: 'Playlists',
        // title: 'Playlist Management',
        type: 'link',
        icontype: 'playlist_play'
    }, {
        path: '/schedulelist',
        title: 'Schedules',
        type: 'link',
        icontype: 'date_range'
    }, {
        path: '/playerlist',
        title: "Players",
        type: 'link',
        icontype: 'queue_play_next'
    }, {
        path: '/medialist',
        title: 'Gallery',
        type: 'link',
        icontype: 'subscriptions'
    },
    //  {
    //     path: '/user',
    //     title: "User's",
    //     type: 'link',
    //     icontype: 'supervisor_account'
    // }
];

//Menu Items
export const ROUTES2: RouteInfo[] = [
    //     {
    //     path: '/dashboard',
    //     title: 'Dashboard',
    //     type: 'link',
    //     icontype: 'dashboard'
    // },
    {
        path: '/superadmin-client-list',
        title: 'Client',
        type: 'link',
        icontype: 'assignment_ind'
    },

];

@Component({
    selector: 'app-sidebar-cmp',
    templateUrl: 'sidebar.component.html',
})

export class SidebarComponent implements OnInit {
    public menuItems: any[];
    token: any;
    userDetail: any;
    ipAddr: any;
    profilePic: any;
    userName: any;
    pageInfo: any;
    template: any = null;

    constructor(private router: Router, public service: DataService, public httpService: HttpService, private activatedRoute: ActivatedRoute) {
        this.ipAddr = this.service.ipaddr;
        console.log(this.router.url);
        this.router.events
            .filter(event => event instanceof NavigationEnd)
            .map(() => this.activatedRoute)
            .map(route => {
                while (route.firstChild) route = route.firstChild;
                return route;
            })
            .filter(route => route.outlet === 'primary')
            .mergeMap(route => route.data)
            .subscribe((event) => {
                // this.titleService.setTitle(event['title']);
                this.pageInfo = event;
                console.log("page ", this.pageInfo);
                if (this.pageInfo.title == 'Content Create') {
                    if (this.service.staticContent) {
                        this.template = 1;
                    } else {
                        this.template = 2;
                    }
                    console.log(this.template)
                } else {
                    this.template = null;
                }
            });

    }


    ngOnInit() {
        let cred = JSON.parse(localStorage.getItem('cred'))
        if (cred != null && cred != undefined) {
            this.token = cred.token;
            this.getUserInfo();
        } else {
            this.router.navigate(['/auth/start']);
        }
    }

    getUserInfo() {
        console.log(JSON.parse(localStorage.getItem('user')))
        if (this.service.variableCheckNotNullIsObject(JSON.parse(localStorage.getItem('user')))) {
            this.userDetail = JSON.parse(localStorage.getItem('user')).user[0];
            this.userName = this.userDetail.name;
            if (this.userDetail.role == 'admin') {
                this.menuItems = ROUTES.filter(menuItem => menuItem);
            } else if (this.userDetail.role == 'user') {
                this.menuItems = ROUTES1.filter(menuItem => menuItem);
            } else if (this.userDetail.role == 'superAdmin') {
                this.menuItems = ROUTES2.filter(menuItem => menuItem);
            }
            if (this.service.variableCheckNotNullIsObject(this.userDetail.image)) {
                this.profilePic = this.ipAddr + this.userDetail.image.path;
            } else {
                this.profilePic = 'assets/img/saul.jpg';
            }
        } else {
            this.profilePic = 'assets/img/saul.jpg';
        }
    }

    isMobileMenu() {
        if ($(window).width() > 991) {
            return false;
        }
        return true;
    };

    updatePS(): void {
        if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
            const elemSidebar = <HTMLElement>document.querySelector('.sidebar .sidebar-wrapper');
            let ps = new PerfectScrollbar(elemSidebar, { wheelSpeed: 2, suppressScrollX: true });
        }
    }

    isMac(): boolean {
        let bool = false;
        if (navigator.platform.toUpperCase().indexOf('MAC') >= 0 || navigator.platform.toUpperCase().indexOf('IPAD') >= 0) {
            bool = true;
        }
        return bool;
    }

    logout() {
        localStorage.clear();
        this.router.navigate(['/auth/start'], { queryParams: { page: 'login' } });
        // this.router.navigate(['/auth/start']);
    }

    gotoHome() {
        this.router.navigate(['dashboard']);
    }
}


// , {
//     path: '/components',
//     title: 'Components',
//     type: 'sub',
//     icontype: 'apps',
//     collapse: 'components',
//     children: [
//         { path: 'buttons', title: 'Buttons', ab: 'B' },
//         { path: 'grid', title: 'Grid System', ab: 'GS' },
//         { path: 'panels', title: 'Panels', ab: 'P' },
//         { path: 'sweet-alert', title: 'Sweet Alert', ab: 'SA' },
//         { path: 'notifications', title: 'Notifications', ab: 'N' },
//         { path: 'icons', title: 'Icons', ab: 'I' },
//         { path: 'typography', title: 'Typography', ab: 'T' }
//     ]
// }, {
//     path: '/forms',
//     title: 'Forms',
//     type: 'sub',
//     icontype: 'content_paste',
//     collapse: 'forms',
//     children: [
//         { path: 'regular', title: 'Regular Forms', ab: 'RF' },
//         { path: 'extended', title: 'Extended Forms', ab: 'EF' },
//         { path: 'validation', title: 'Validation Forms', ab: 'VF' },
//         { path: 'wizard', title: 'Wizard', ab: 'W' }
//     ]
// }, {
//     path: '/tables',
//     title: 'Tables',
//     type: 'sub',
//     icontype: 'grid_on',
//     collapse: 'tables',
//     children: [
//         { path: 'regular', title: 'Regular Tables', ab: 'RT' },
//         { path: 'extended', title: 'Extended Tables', ab: 'ET' },
//         { path: 'datatables.net', title: 'Datatables.net', ab: 'DT' }
//     ]
// }, {
//     path: '/maps',
//     title: 'Maps',
//     type: 'sub',
//     icontype: 'place',
//     collapse: 'maps',
//     children: [
//         { path: 'google', title: 'Google Maps', ab: 'GM' },
//         { path: 'fullscreen', title: 'Full Screen Map', ab: 'FSM' },
//         { path: 'vector', title: 'Vector Map', ab: 'VM' }
//     ]
// }, {
//     path: '/widgets',
//     title: 'Widgets',
//     type: 'link',
//     icontype: 'widgets'

// }, {
//     path: '/charts',
//     title: 'Charts',
//     type: 'link',
//     icontype: 'timeline'

// }, {
//     path: '/calendar',
//     title: 'Calendar',
//     type: 'link',
//     icontype: 'date_range'
// }, {
//     path: '/pages',
//     title: 'Pages',
//     type: 'sub',
//     icontype: 'image',
//     collapse: 'pages',
//     children: [
//         { path: 'pricing', title: 'Pricing', ab: 'P' },
//         { path: 'timeline', title: 'Timeline Page', ab: 'TP' },
//         { path: 'login', title: 'Login Page', ab: 'LP' },
//         { path: 'register', title: 'Register Page', ab: 'RP' },
//         { path: 'lock', title: 'Lock Screen Page', ab: 'LSP' },
//         { path: 'user', title: 'User Page', ab: 'UP' }
//     ]
// }